export const webDomains = [
  // localhost
  'http://localhost:8000/',
  // dev
  'https://web.dev.resy.com/',
  'https://resy-web.dev.resy.com/',
  // staging
  'https://web.staging.resy.com/',
  'https://resy-web.staging.resy.com/',
  'https://staging-web.resy.com/',
  // demo
  'https://web.demo.resy.com/',
  'https://resy-web.demo.resy.com/',
  'https://demo-web.resy.com/',
  // prod
  'https://resy.com/',
];

const checkIfResyWebUrl = (url) => webDomains.includes(url);

export default checkIfResyWebUrl;
